import React from 'react'
import { Grid, TextField, Typography, Divider } from '@material-ui/core'
import Autocomplete from '@material-ui/lab/Autocomplete'
import { Page, Header, CustomButton, ModalConfirmacao } from 'components'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import CheckIcon from '@material-ui/icons/Check'
import useStyles from './styles'
import { useConsumirVestigio } from './hooks/useConsumirVestigio'

export const ConsumirVestigio = (props) => {
  const { route } = props
  const classes = useStyles()

  const {
    formExameDoCaso,
    examesDoCaso,
    processando,
    abrirEspelho,
    handleOpen,
    handleClose,
    handleConfirmar,
    isFormValid,
    router,
    params,
  } = useConsumirVestigio()

  return (
    <Page className={classes.root} title={`${route.titulo} - SIGEP`}>
      <Header titulo={route.titulo} overline={route.secao} pathname={router.location.pathname} router={router} />
      
      <div className={classes.results}>
        <Grid container>
          
          <Grid className={classes.camposFormulario} item xs={12}>
            <TextField
              id="lacre"
              disabled
              fullWidth
              label="LACRE"
              name="lacre"
              variant="outlined"
              InputLabelProps={{
                shrink: true,
              }}
              value={formExameDoCaso.formState.values.lacre || 'NÃO INFORMADO'}
            />
          </Grid>

          <Grid className={classes.camposFormulario} item xs={12}>
            <Autocomplete
              disablePortal
              name="exReal"
              fullWidth
              noOptionsText="Sem informações"
              value={formExameDoCaso.formState.values.exReal || null}
              onChange={(event, newValue) => formExameDoCaso.handleChangeNewValueByNameProperty(event, newValue, 'exReal')}
              options={examesDoCaso}
              getOptionLabel={(option) => `${option.numeroExame} - ${option.exSol?.tipoEx?.nome || 'TIPO NÃO IDENTIFICADO'}`}
              getOptionSelected={(option, value) => option.id === value?.id}
              renderOption={(option) => `${option.numeroExame} - ${option.exSol?.tipoEx?.nome || 'TIPO NÃO IDENTIFICADO'}`}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  label="Exame que consumiu o vestígio"
                  required
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              )}
            />
          </Grid>

          <Grid className={classes.camposFormulario} item xs={12}>
            <TextField
              name="observacao"
              fullWidth
              multiline
              variant="outlined"
              minRows={10}
              required
              label="Observação"
              error={formExameDoCaso.hasError('observacao')}
              helperText={formExameDoCaso.hasError('observacao') ? formExameDoCaso.formState.errors.observacao[0] : null}
              onChange={(e) => formExameDoCaso.handleChange(e)}
              value={formExameDoCaso.formState.values.observacao || ''}
              InputLabelProps={{
                shrink: true,
              }}
            />
            <Typography variant="caption" style={{ display: 'block', marginTop: '4px' }}>
              Caracteres restantes: {250 - (formExameDoCaso.formState.values.observacao?.length || 0)}
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <Divider className={classes.dividerBotoes} />
            <div className={classes.botoesFormulario}>
              <CustomButton
                colorType="primary"
                variant="outlined"
                onClick={() => router.history.push(`/casos/caso/vestigio/detalhar/${params.id}`)}
                startIcon={<ArrowBackIcon />}
              >
                Voltar
              </CustomButton>
              <CustomButton
                colorType="primary"
                disabled={!isFormValid || processando}
                isLoading={processando}
                startIcon={<CheckIcon />}
                onClick={handleOpen}
              >
                Confirmar
              </CustomButton>
            </div>
          </Grid>

        </Grid>
      </div>

      <ModalConfirmacao
        aberto={abrirEspelho}
        onClose={handleClose}
        onConfirm={handleConfirmar}
        processando={processando}
        titulo="CONFIRMAÇÃO DOS DADOS PREENCHIDOS"
        confirmarLabel="Confirmar"
        cancelarLabel="Cancelar"
        confirmarColor="secondary"
        maxWidth="md"
      >
        <Grid container spacing={2}>
          <Grid item md={6} xs={12}>
            <Typography variant="body2" color="textSecondary">LACRE</Typography>
            <Typography variant="body1"><b>{formExameDoCaso.formState.values.lacre || 'NÃO INFORMADO'}</b></Typography>
          </Grid>
          <Grid item md={6} xs={12}>
            <Typography variant="body2" color="textSecondary">EXAME REALIZADO</Typography>
            <Typography variant="body1">
              <b>
                {formExameDoCaso.formState.values.exReal
                  ? `${formExameDoCaso.formState.values.exReal.numeroExame} - ${formExameDoCaso.formState.values.exReal.exSol?.tipoEx?.nome || ''}`
                  : 'NÃO INFORMADO'}
              </b>
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body2" color="textSecondary">OBSERVAÇÃO</Typography>
            <Typography variant="body1"><b>{formExameDoCaso.formState.values.observacao || 'NÃO INFORMADO'}</b></Typography>
          </Grid>
        </Grid>
      </ModalConfirmacao>
    </Page>
  )
}

export default ConsumirVestigio
